import {colord, extend} from 'colord';
import a11yPlugin from 'colord/plugins/a11y';

import {scToTwColour} from '../../../theme';

import type {PieBarDatum} from './types';

export function truncate(str: string, n: number): string {
  return str.length > n ? str.slice(0, n - 1) + '...' : str;
}

export function constructPieBarDatum(
  item: {id: string; colour: string; name: string},
  value: number,
  totalValue: number
): PieBarDatum {
  return {
    name: item.name,
    value,
    fill: item.colour,
    id: item.id,
    percent: parseFloat(((value / totalValue) * 100).toFixed(1)),
  };
}

export function getTextColour(fill: string): 'white' | 'black' {
  extend([a11yPlugin]); // TODO: Move this to a more global location
  return colord(scToTwColour('theme.colors.white', true)).isReadable(fill, {
    level: 'AA',
    size: 'normal',
  })
    ? 'white'
    : 'black';
}
